'use client'

import { clsx } from 'clsx'
import type { ResponsiveLevel } from '../../theme/media'
import type { PolymorphicComponentsProps } from '../TypeUtils'
import { Typography, type TypographyVariant } from '../Typography/Typography'
import { type Sprinkles, sprinkles } from '../../theme/sprinkles.css'

type HeadingColors = Extract<
  Sprinkles['color'],
  | 'textPrimary'
  | 'textSecondary'
  | 'textNegative'
  | 'textTranslucentPrimary'
  | 'textTranslucentSecondary'
  | 'textTranslucentTertiary'
>

export type HeadingProps = PolymorphicComponentsProps<
  'h1' | 'h2' | 'h3' | 'h4' | 'p',
  {
    color?: HeadingColors
    variant?: TypographyVariant | Partial<Record<ResponsiveLevel, TypographyVariant>>
    align?: Sprinkles['textAlign']
    balance?: boolean
  }
>

export function Heading({
  as,
  className,
  color = 'textPrimary',
  variant = 'standard.32',
  align,
  balance,
  children,
  ...rest
}: HeadingProps) {
  const Component = as ?? 'h2'

  return (
    <Typography
      variant={variant as TypographyVariant}
      align={align}
      balance={balance}
      className={clsx(className, sprinkles({ color }))}
      asChild
      {...rest}
    >
      <Component>{children}</Component>
    </Typography>
  )
}
